import * as React from 'react';
import {
  Scale,
  Languages,
  FileSearch,
  FileText,
  SpellCheck,
  Info,
  AlignLeft,
  ArrowLeftRight,
  List,
  GitCompare,
  CheckSquare,
  MessageSquarePlus,
} from 'lucide-react';
import './SolutionsGrid.css';

export type SolutionId = 'master_cross_checks' | 'construction_loan';

export type GenericSolutionId =
  | 'legal_translation'
  | 'favor_a_party'
  | 'contract_review'
  | 'legal_tone'
  | 'language_check'
  | 'explain'
  | 'tldr'
  | 'make_mutual'
  | 'summary'
  | 'redline_analyzer'
  | 'make_standard'
  | 'enhance_argumentation';

interface SolutionCube {
  id: SolutionId;
  label: string;
  icon: React.ReactNode;
}

interface GenericSolutionCube {
  id: GenericSolutionId;
  label: string;
  icon: React.ReactNode;
}

const COURTYARD_SOLUTIONS: SolutionCube[] = [
  {
    id: 'master_cross_checks',
    label: 'Master Cross Checks',
    icon: <Scale className="solution-cube-icon" size={22} strokeWidth={1.5} />,
  },
  {
    id: 'construction_loan',
    label: 'Construction Loan Agreement',
    icon: <FileText className="solution-cube-icon" size={22} strokeWidth={1.5} />,
  },
];

const GENERIC_SOLUTIONS: GenericSolutionCube[] = [
  { id: 'legal_translation', label: 'Legal Translation', icon: <Languages className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'favor_a_party', label: 'Favor a party', icon: <Scale className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'contract_review', label: 'Contract review', icon: <FileSearch className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'legal_tone', label: 'Legal tone', icon: <FileText className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'language_check', label: 'Language Check', icon: <SpellCheck className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'explain', label: 'Explain', icon: <Info className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'tldr', label: 'TL;DR', icon: <AlignLeft className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'make_mutual', label: 'Make mutual', icon: <ArrowLeftRight className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'summary', label: 'Summary', icon: <List className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'redline_analyzer', label: 'Redline analyzer', icon: <GitCompare className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'make_standard', label: 'Make standard', icon: <CheckSquare className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
  { id: 'enhance_argumentation', label: 'Enhance argumentation', icon: <MessageSquarePlus className="solution-cube-icon" size={20} strokeWidth={1.5} /> },
];

interface SolutionsGridProps {
  onSelect: (id: SolutionId) => void;
  onSelectGeneric?: (id: GenericSolutionId) => void;
}

export const SolutionsGrid: React.FC<SolutionsGridProps> = ({ onSelect, onSelectGeneric }) => {
  return (
    <div className="solutions-grid-container">
      <section className="solutions-section">
        <h3 className="solutions-section-title">Courtyard Solutions</h3>
        <div className="solutions-grid">
          {COURTYARD_SOLUTIONS.map((solution) => (
            <button
              key={solution.id}
              type="button"
              className="solution-cube"
              onClick={() => onSelect(solution.id)}
            >
              <span className="solution-cube-icon-wrap">{solution.icon}</span>
              <span className="solution-cube-label">{solution.label}</span>
            </button>
          ))}
        </div>
      </section>

      <section className="solutions-section">
        <h3 className="solutions-section-title">Generic Solutions</h3>
        <div className="solutions-grid solutions-grid-generic">
          {GENERIC_SOLUTIONS.map((solution) => (
            <button
              key={solution.id}
              type="button"
              className="solution-cube solution-cube-generic"
              onClick={() => onSelectGeneric?.(solution.id)}
              title={onSelectGeneric ? undefined : 'Coming soon'}
            >
              <span className="solution-cube-icon-wrap">{solution.icon}</span>
              <span className="solution-cube-label">{solution.label}</span>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};
